import type { StoreLocation } from '../types/services/auth';

export const filterLocationsForReceiptReport = (
  locations: StoreLocation[],
  reportType?: string,
): StoreLocation[] => {
  const normalizedReportType = String(reportType || '').toLowerCase();
  if (normalizedReportType === 'ticket_balance') {
    return locations.filter((location) => location.location_type === 'counter');
  }
  if (normalizedReportType.startsWith('vending_')) {
    return locations.filter((location) => location.location_type === 'vending');
  }
  return locations;
};
